import { forwardRef } from 'react';

import { Card } from '@sravni/react-design-system/lib/Card';
import { Heading, ListItem, UnorderedList, Text } from '@sravni/react-design-system/lib/Typography';
import { Check } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import cn from 'classnames';
import type { GiftBannerProps } from './types';
import styles from './GiftBanner.module.scss';
import { GiftBannerTexts } from './GiftBanner.texts';
import GiftImage from './images/img.png';
import GiftImageDesktop from './images/imgDesktop.png';

export const GiftBanner = forwardRef<HTMLDivElement, GiftBannerProps>((props, ref) => {
    const { className, children, ...rest } = props;
    const isMobile = useIsMobile();

    return (
        <Card ref={ref} size={isMobile ? 16 : 24} color="light" className={cn(styles.card, className)} {...rest}>
            <img src={GiftImage} alt="gift" className={cn(styles.gift)} />
            <img src={GiftImageDesktop} alt="gift" className={cn(styles.giftDesktop)} />

            <Text size={10} className={styles.tag}>
                {GiftBannerTexts.TagLabel}
            </Text>

            <Heading level={5} className="h-mt-8">
                {GiftBannerTexts.Header}
            </Heading>
            <UnorderedList className="h-mt-12">
                {GiftBannerTexts.featuresListTexts.map((featureText, i) => (
                    <ListItem key={`i-${i}`} className={styles.listItem} icon={<Check className={styles.icon} />}>
                        <Text size={12}>{featureText}</Text>
                    </ListItem>
                ))}
                {children ? <ListItem className={styles.inject}>{children}</ListItem> : null}
            </UnorderedList>
        </Card>
    );
});

GiftBanner.displayName = 'GiftBanner';
